import React, { useState } from 'react'

import { Box, IconBadge, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  categoryTemplateListExtended,
  customCategory,
} from 'modules/finance/lib/newSpendingPoliciesWizard'

import IconListModal from './IconListModal'

interface IconSelectorProps {
  defaultIcon?: string | null
  setIcon: (icon: string) => void
}

const IconSelector = ({ defaultIcon, setIcon }: IconSelectorProps) => {
  const categoryInfo =
    categoryTemplateListExtended().find((c) => c.icon === defaultIcon) || customCategory()

  const [showIconListModal, setShowIconListModal] = useState(false)
  return (
    <Box gap="s8">
      <Box gap="s2">
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('spending_policies.details.form.icon.label')}
          </Text.Normal>
        </Box>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box
          onClick={() => setShowIconListModal(true)}
          aria-label={i18n.t('spending_policies.details.form.icon.description')}
        >
          <IconBadge
            icon={categoryInfo.icon}
            size="s32"
            color={categoryInfo.color}
            iconColor={categoryInfo.badgeColor}
          />
        </Box>
      </Box>
      {showIconListModal && (
        <IconListModal
          setIcon={setIcon}
          defaultIcon={String(defaultIcon)}
          closeModal={() => setShowIconListModal(false)}
        />
      )}
    </Box>
  )
}

export default React.memo(IconSelector)
